<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        title="문의사항"
        pace="6"
      >
        리토스에서는 여러분의 연락을 항상 기다립니다.<br>서비스 사용방법, 설치 및 도입 등 문의사항이 있으시면 언제든지 연락 주세요.<br>
        내일로의 도약을 위한 작은 변화. 리토스가 함께 합니다.
      </base-info-card>

      <base-business-contact dense />
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessInfo',

    props: { dark: Boolean },

    data: () => ({

    }),
  }
</script>
